/**
 * Enum for different device types
 */
export var DeviceType;
(function (DeviceType) {
    /**
     * Represents a desktop device.
     */
    DeviceType["DESKTOP"] = "desktop";
    /**
     * Represents a mobile device.
     */
    DeviceType["MOBILE"] = "mobile";
    /**
     * Represents a tablet device.
     */
    DeviceType["TABLET"] = "tablet";
})(DeviceType || (DeviceType = {}));
